module.exports = __webpack_public_path__ + "img/banner03_info_business.83085fd7.svg";